var map = {
	"./auth.js": 4417,
	"./buyer.js": 7700,
	"./company.js": 2428,
	"./dictionary.js": 8963,
	"./doa.js": 6711,
	"./field.js": 2915,
	"./justification.js": 8493,
	"./location.js": 9220,
	"./maintenance.js": 4604,
	"./master.js": 2657,
	"./material.js": 5306,
	"./materialgroup.js": 4439,
	"./materialtype.js": 6898,
	"./modifytype.js": 6273,
	"./partner.js": 37,
	"./testdata.js": 8275,
	"./user.js": 3344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2536;